// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".left-menu .menu{display:flex;flex-direction:column;justify-content:flex-start;list-style:none}.left-menu .menu .submenu{border-left:2px solid #e6e9f2;padding-left:1rem;margin:0.25rem 0}\n", ""]);
// Exports
module.exports = exports;
